import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import styles from './SoftLine.module.less';

import { CONTEXT } from '../../config';
import { logging, logPostInfo } from '../../actions/log';
import Rate from '../../components/Rate/Rate';
import Button from '../../components/Button/Button';
import { useInView } from 'react-intersection-observer';
import {
  logNative,
  getUrlByTargetContent,
  sortSoftsByLocalSoftInit,
  getSoftType,
} from '../../utils/utils';
import { setIframeVisible } from '../../actions/layout';
import _LogInView from '../../components/_LogInView/_LogInView';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);
  const [activitPage, setActivitPage] = useState(0);

  const [showData, setShowData] = useState(null);
  const [showSofts, setShowSofts] = useState([]);
  const [allSofts, setAllSofts] = useState([]);
  const pageSize = 3;
  const LOG_ACTION_SOURCE = {
    c_change: `${logInfo.tag}_Group_Change`,
    source: `${logInfo.tag}_Group_SoftLine`,
    c_more: `${logInfo.tag}_Group_More`,
  };
  const [ref, inView] = useInView({
    threshold: 1,
  });
  const [refDom, inViewDom] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
        org: data && data.dataList && data.dataList[0] && data.dataList[0].org,
      });
    }
  }, [inView]);

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (data && data.dataList && data.dataList.length > 0) {
      const showSoftArr = sortSoftsByLocalSoftInit(data.dataList[0].apps || [], localSoftsInit);
      setShowSofts(showSoftArr.slice(0, pageSize));
      setAllSofts(showSoftArr);
      setShowData(data.dataList[0]);
      handleChangeSoft(showSoftArr, 0, true);
    }
  }, [dispatch, localSoftsInit]);

  const handleSoftCard = useCallback(
    soft => {
      dispatch(
        logging({
          category: 'C',
          action: 'handle_SoftCard',
          label: '',
          param2: {
            source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softId: soft.packageName || soft.softID,
            softName: soft.softName,
            type: soft.androidType !== '1' ? 0 : 1,
          },
          param3: soft.bizInfo,
        }),
      );
      let url =
        soft.androidType !== '1'
          ? `${CONTEXT}/detail/soft/${soft.softID || ''}/${soft.bizInfo || '{}'}`
          : `${CONTEXT}/adetail/${soft.packageName || ''}/${soft.versionCode}/${
              soft.bizInfo || '{}'
            }`;
      dispatch(
        logPostInfo({
          source_p:
            `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}` ||
            `${logInfo.tag}_Group_SoftLine`,
          source_pp: logInfoData.source_p,
        }),
      );
      history.push(url);
    },
    [showData],
  );

  const handleShowMore = useCallback(
    bannerInfo => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.c_more,
          label: '',
          param2: {
            source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            pageCardContentId: showData.pageCardContentId,
            name: showData.name,
          },
          param3: bannerInfo.bizInfo,
        }),
      );
      history.push(`${CONTEXT}/rankmore?code=${bannerInfo.dataList[0].code}`);
    },
    [dispatch, logInfoData, history, showData],
  );
  /**
   * 每一次change 都是数组中循环展示24个  不够就用数组前面的应用组装成24个  这样依次循环展示
   * 根据保存的页码数，获取当前应该展示的24个应用
   */
  const getAppsByPage = useCallback((softAll = [], page = 1) => {
    if (softAll && softAll.length === 0) {
      return [];
    }
    let softArrLoop = softAll;

    while (page * pageSize > softArrLoop.length) {
      softArrLoop = softArrLoop.concat(softAll);
    }
    return softArrLoop.slice((page - 1) * pageSize, page * pageSize);
  }, []);

  const handleChangeSoft = useCallback(
    (allSoft, page, flag) => {
      setActivitPage(page + 1);
      setShowSofts(getAppsByPage(allSoft, page + 1));

      // 点击换一换, flag第一次切换不上报
      if (!flag) {
        dispatch(
          logging({
            category: 'C',
            action: LOG_ACTION_SOURCE.c_change,
            label: '',
            param2: {
              source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              pageCardContentId: showData.pageCardContentId,
              name: showData.name,
            },
          }),
        );
      }
    },
    [dispatch, logInfoData, history, showData],
  );
  return showData && showData.apps && showData.apps.length > 0 ? (
    <div
      className={inViewDom ? styles.card_cardIn : styles.card_cardOut}
      ref={ref}
      data-item={data.cardType}
    >
      <div className={styles.card} ref={refDom}>
        {inViewDom && (
          <>
            <div className={styles.card_header}>
              <div className={styles.card_header_title}>{data.title}</div>
              {data.operate === '2' && (
                <div className={styles.card_header_more} onClick={() => handleShowMore(data)}>
                  更多
                </div>
              )}
              {data.operate === '1' && (
                <div
                  className={styles.header_change}
                  onClick={() => {
                    handleChangeSoft(allSofts, activitPage);
                  }}
                >
                  <i className={`iconfont icon-refresh1 ${styles.header_change_icon}`} />
                  <span>换一换</span>
                </div>
              )}
            </div>
            {showSofts.map((soft, index) => {
              return (
                <div className={styles.soft_item_box} key={index}>
                  <_LogInView
                    cardData={soft}
                    logInfo={{
                      ...logInfo,
                      ///////////////////////////
                      softid: soft?.androidType === '1' ? soft?.packageName : soft?.softID,
                      softType: getSoftType(soft),
                      contentType: 'soft',
                      rankCode: showData.code,
                      org: showData.org || '',
                      cardType: data.cardType,
                      cardName: data.cardType,
                      pageCardTitle: data.title,
                      pageCardId: showData.pageCardContentId,
                      ///////////////////////////
                      source: `${logInfo.tag}_Group_SoftLine`,
                      source_p: logInfoData.source_p,
                      source_pp: logInfoData.source_pp,
                    }}
                  >
                    <div className={styles.soft_item}>
                      <div
                        className={styles.soft_img_box}
                        onClick={() => {
                          handleSoftCard(soft);
                        }}
                      >
                        <img className={styles.soft_img} src={soft.logoFile} />
                        {soft.androidType === '1' && <div className={styles.soft_img_logo} />}
                      </div>
                      <div className={styles.soft_info}>
                        <div className={styles.soft_info_top}>
                          <div
                            className={styles.soft_info_name}
                            onClick={() => {
                              handleSoftCard(soft);
                            }}
                          >
                            {soft.softName}
                          </div>
                          <div className={styles.soft_info_name_desc}>
                            {soft.downloadProportionDesc}
                          </div>
                        </div>
                        <div className={styles.soft_info_desc}>{soft.introduction || ''}</div>
                      </div>
                      <div className={styles.soft_info2}>
                        <div className={styles.soft_info2_size}>{soft.installFileSize}</div>
                        <div className={styles.soft_info2_dl}>
                          {soft.downloadCount || '0次'}安装
                        </div>
                      </div>
                      <div className={styles.soft_info3}>
                        <div className={styles.soft_info2_score}>
                          <Rate
                            score={(Number(soft.score) / 20).toFixed(1)}
                            rateInfo={{ className: styles.soft_score }}
                          />
                          <span className={styles.soft_info2_score_num}>
                            {(Number(soft.score) / 20).toFixed(1)}
                          </span>
                        </div>
                        <div
                          className={styles.soft_info2_text}
                        >{`${soft.commentUserCount}人打分`}</div>
                      </div>
                      <div className={styles.soft_btn}>
                        <Button
                          soft={soft}
                          info={{
                            className: styles.soft_btn,
                            className_busing: styles.soft_btn_b,
                            className_open: styles.soft_button_open,
                          }}
                          // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
                          logInfo={{
                            ...logInfo,
                            source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
                          }}
                        />
                      </div>
                    </div>
                  </_LogInView>
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  ) : (
    ''
  );
});
